import { createSvgIcon } from '../../createSvgIcon';
import { CHEVRON_PATH_D } from '../chevronPath';

export const ChevronDownIcon = createSvgIcon(
  <g transform="translate(27, 0) rotate(90)">
    <path d={CHEVRON_PATH_D} fill="currentColor" />
  </g>,
  { displayName: 'ChevronDownIcon', viewBox: '0 0 27 15' }
);
